import React, { useEffect, useState } from 'react';
import Navigation from '../components/Navigation';
import { NavLink } from 'react-router-dom';
import base_url from '../config/Config';
import axios from 'axios';
import Sidebar from '../components/Sidebar';
import Spinner from 'react-bootstrap/Spinner';
import {  } from 'react-icons/fa';
import PageLoader from '../components/PageLoader';

const CreditCheck = () => {
    const [creditCheck, setCreditCheck] = useState([]);
    const [pageLoading, setPageLoading] = useState(true);
    const [rejectList, setRejectList] = useState([]); 
    const [isLoading, setIsLoading] = useState(false);
    const [isDownloading, setIsDownloading] = useState(false);
    const [showRejectList, setShowRejectList] = useState(false); 
    const [showCreditCheck, setShowCreditCheck] = useState(true); 
    const [searchOption, setSearchOption] = useState('');
    const [searchInput, setSearchInput] = useState('');
    
    const getCreditCheck = async () => {
        try {
            const response = await axios.get(`${base_url}/api1/customer/customerStatus?status=Credit check`);
            const filteredCreditCheck = response.data.map(CreditCheck => ({
                ...CreditCheck,
                actionPerformed: false,
            }));
            setCreditCheck(filteredCreditCheck.reverse());
        } catch (error) {
            console.error('Error fetching Credit Check data:', error);
        } finally {
            setPageLoading(false);
        }
    };

    const getRejectList = async () => {
        try {
            const response = await axios.get(`${base_url}/api1/cibil/rejectStatus?status=Credit reject`);
            const filteredRejectList = response.data.map(rejectItem => ({
                ...rejectItem,
                actionPerformed: false,
            }));
            setRejectList(filteredRejectList.reverse());
        } catch (error) {
            console.error('Error fetching Reject List data:', error);
        }
    };

    useEffect(() => {
        if (showCreditCheck) {
            getCreditCheck();
        } else if (showRejectList) {
            getRejectList();
        }
    }, [showCreditCheck, showRejectList]);

    const handleShowCreditCheck = () => {
        setShowCreditCheck(true);
        setShowRejectList(false);
    };

    const handleShowRejectList = () => {
        setShowRejectList(true);
        setShowCreditCheck(false);
    };

    const handleExportCreditCheck = async () => {
        setIsDownloading(true);
        try {
            const response = await axios.get(`${base_url}/api1/creditCheck/creditCheckToExport`, {
                responseType: 'blob'
            });

            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'Pending_creditCheck_data.xlsx');
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);

            alert('Export Pending CreditCheck Data successfully');
        } catch (error) {
            console.error('Error generating export:', error.response?.data || error.message);
            alert('Export Pending CreditCheck Data failed');
        } finally {
            setIsDownloading(false);
        }
    };

    const handleKycCheck = async (id) => {
        setIsLoading(true); 

        try {
            const response = await axios.put(`${base_url}/api1/customer/kyc?id=${id}`);
            if (response.status === 200) {
                alert(`KYC check for ID ${id} was successful.`);
            }
        } catch (error) {
            console.error('Error performing KYC check:', error.response?.data || error.message);
            alert('KYC check failed.');
        }
        finally {
            setIsLoading(false); 
        }
    };



    
// search filter API 
const handleSearch = (event) => {
    event.preventDefault();
    if (searchOption && searchInput) {
        let url = '';
        switch (searchOption) {
            case 'borrower_name':
                url = `${base_url}/api1/customer/searchByBorrowerName?borrowerName=${searchInput}`;
                break;
            case 'borrower_id':
                url = `${base_url}/api1/customer/searchByBorrowerId?borrowerId=${searchInput}`;
                break;
            case 'phone':
                url = `${base_url}/api1/customer/searchByMobileNumber?mobileNumber=${searchInput}`;
                break;
            default:
                break;
        }
        axios.get(url).then(
            (response) => {
                console.log(response.data);
                setCreditCheck(response.data);
            },
            (error) => {
                console.log(error);
            }
        );
    }
};

// search filter API end 
    if (pageLoading) return <PageLoader text="Loading..." />;

    return (
        <>
            <div className='overviewsaa'>
                <h4>CreditCheck Details</h4>
            </div>
            <div className='navigationss mb-5'>
                <Navigation />
            </div>
            <div className='container-fluid'>
                <div className='row'>
                    <div className='col-lg-2 col-md-2 sidebarnavigartion'>
                        <div className='lmssidebar'>
                            <Sidebar />
                        </div>
                    </div>
                    <div className='col-lg-10 col-md-10'>
                        <div className='dashboardlms mt-5 text-center'>
                            <div className='row'>
                                <div className='col-md-12'>
                                    <div className='searchtoll'>
                                        <form name="searchForm" action="">
                                            <div className='row'>
                                            <div className="col-md-2 col-3">
                                                    <div className=" required">
                                                        <select name="option" id="option" className="form-control" value={searchOption} onChange={(e) => setSearchOption(e.target.value)} required="required">
                                                            <option value="" selected="selected">Search By</option>
                                                            <option value="borrower_name">Borrower Name</option>
                                                            <option value="borrower_id">Partner Id</option>
                                                            <option value="phone">Phone</option>
                                                        </select>
                                                    </div>
                                                </div>
                                                <div className="col-md-4 col-6">
                                                    <div className=" required">
                                                        <input type="text" className="form-control" placeholder="Search..." value={searchInput} onChange={(e) => setSearchInput(e.target.value)} required/>
                                                    </div>
                                                </div>
                                                <div className="col-md-1 col-3">
                                                    <div className=" required iconsss">
                                                        <button type="submit" onClick={handleSearch} className="btn btn-sm btn-primary">Search</button>
                                                    </div>
                                                </div>
                                                <div className='col-md-2 col-5 mt-2'>
                                                    <div className='rejectlist'>
                                                        <NavLink to="#" onClick={handleShowCreditCheck}>Credit Checked</NavLink>
                                                    </div>
                                                </div>
                                                <div className='col-md-2 col-4 mt-2'>
                                                    <div className='rejectlist'>
                                                        <NavLink to="#" onClick={handleShowRejectList}>Credi_Reject</NavLink>
                                                    </div>
                                                </div>
                                                
                                                <div className="col-md-1 col-3 mt-2">
                                                    <div className="export">
                                                        <NavLink to="#" className="exportbutton" onClick={handleExportCreditCheck}>
                                                            {isDownloading ? (
                                                                <Spinner animation="border" size="sm" />
                                                            ) : (
                                                                <>
                                                                    Export  
                                                                </>
                                                            )}
                                                        </NavLink>
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                                <div className='col-md-12 col-lg-12'>
                                    <div className='kyc table-responsive allcustomer mt-3 mb-5'>
                                        {showRejectList && rejectList.length > 0 && (
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>S_Id</th>
                                                        <th>Emp_Id</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Date_of_Birth</th>
                                                        <th>Pan_number</th>
                                                        <th>Gender</th>
                                                        <th>Phone_Number</th>
                                                        <th>Bureau_Type</th>
                                                        <th>Credit_Score</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {rejectList.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.id}</td>
                                                            <td>{data.empId}</td>
                                                            <td>{data.borrowerName}</td>
                                                            <td>{data.dob}</td>
                                                            <td>{data.panNumber}</td>
                                                            <td>{data.gender}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.bureauType}</td>
                                                            <td>{data.bureauScore}</td>
                                                            <td>
                                                            <button onClick={() => handleKycCheck(data.id)} disabled={isDownloading} >
                                                             {isDownloading ? "Processing..." : "KYC Check"}
                                                            </button>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                        {showRejectList && rejectList.length === 0 && (
                                            "No Rejected CreditCheck today."
                                        )}
                                        {showCreditCheck && creditCheck.length > 0 && (
                                            <table>
                                                <tbody>
                                                    <tr>
                                                        <th>Salora_Id</th>
                                                        <th>Emp_Id</th>
                                                        <th>Borrower_Name</th>
                                                        <th>Date_of_Birth</th>
                                                        <th>Pan_Number</th>
                                                        <th>Gender</th>
                                                        <th>Phone_Number</th>
                                                        <th>Bureau_Type</th>
                                                        <th>Credit_Score</th>
                                                        <th>Action</th>
                                                    </tr>
                                                    {creditCheck.map((data, index) => (
                                                        <tr key={index}>
                                                            <td>{data.id}</td>
                                                            <td>{data.empId}</td>
                                                            <td>{data.borrowerName}</td>
                                                            <td>{data.dob}</td>
                                                            <td>{data.panNumber}</td>
                                                            <td>{data.gender}</td>
                                                            <td>{data.mobileNumber}</td>
                                                            <td>{data.bureauType}</td>
                                                            <td>{data.bureauScore}</td>
                                                            <td className='creditcheck'> <button onClick={() => handleKycCheck(data.id)} disabled={isLoading} >
                                                             {isLoading ? "Processing..." : "KYC_Check"}
                                                            </button></td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        )}
                                        {showCreditCheck && creditCheck.length === 0 && (
                                            "No CreditCheck today."
                                        )}
                                    </div>
                                </div>
                                <hr />
                              
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreditCheck;
